import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const SchoolDetail1 = () => {

	const App = useApp()
	const [menuOpen, setMenuOpen] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: "어린이집 상세",
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding">
					{/* 지도 영역 */}
					<div style={{ height: "20rem", background: "#f5f5f5" }}></div>
					<div className={`${styles["school-list"]} flex-justify_between mt_40`}>
						<div>
							<i className="tag tag-box tag-gray">국공립</i>
							<p className="mt_5">국공립아라유승한내들어린이집</p>
							<div className={`${styles["tag-area"]} mt_10`}>
								<span>#시간연장형</span>
								<span>#제공서비스</span>
							</div>
						</div>
						<div className={styles["call-btn"]}>
							<i className="icon icon_call" />
						</div>
					</div>
				</div>
			</div>
			<div className="padding">
				<ul className={`${styles["school-detail"]} accordion-list`}>
					<li onClick={() => setMenuOpen(0)} className={menuOpen === 0 ? "active" : ""}>
						<div className={`${styles["list-title"]}`}>
							<p>기본정보</p>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							<div className={styles.box}>
								<ul className={styles["user-info"]}>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_calendar icon mr_5" />
											<span>인가일자 : 2000.09.14</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_bus icon mr_5" />
											<span>통학 차량 운영</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_mail icon mr_5" />
											<span>www.naver.com</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_call icon mr_5" />
											<span>032-1234-5678</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_fax icon mr_5" />
											<span>-</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_place icon mr_5" />
											<span>인천광역시 서구 이음3로 130 관리동<i className="icon icon_copy ml_5" /></span>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</li>
					<li onClick={() => setMenuOpen(1)} className={menuOpen === 1 ? "active" : ""}>
						<div className={`${styles["list-title"]}`}>
							<p>원아</p>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							<div className={styles.box}>
								<div className={styles["list-item"]}>
									<div>
										<span>원아 수</span>
										<span><span className="text-blue">83</span>/100명(83%)</span>
									</div>
								</div>
								<hr className="my_30" />
								<div>연령별 원아(반 수)</div>

								<ul className={`${styles["count-bar"]} mt_20`}>
									<li>
										<span>만 0세</span>
										<div className={styles.bar}>
											<span style={{ width: "80%" }}>
												<span>14명</span>
											</span>
										</div>
									</li>
									<li>
										<span>만 1세</span>
										<div className={styles.bar}>
											<span style={{ width: "60%" }}>
												<span>9명</span>
											</span>
										</div>
									</li>
									<li>
										<span>만 2세</span>
										<div className={styles.bar}>
											<span style={{ width: "45%" }}>
												<span>7명</span>
											</span>
										</div>
									</li>
									<li>
										<span>만 0세~2세</span>
										<div className={styles.bar}>
											<span style={{ width: "42%" }}>
												<span>6명</span>
											</span>
										</div>
									</li>
									<li>
										<span>만 3세</span>
										<div className={styles.bar}>
											<span style={{ width: "35%" }}>
												<span>4명</span>
											</span>
										</div>
									</li>
									<li>
										<span>만 4세</span>
										<div className={styles.bar}>
											<span style={{ width: "35%" }}>
												<span>4명</span>
											</span>
										</div>
									</li>
									<li>
										<span>만 5세</span>
										<div className={styles.bar}>
											<span style={{ width: "30%" }}>
												<span>3명</span>
											</span>
										</div>
									</li>
									<li>
										<span>만 3세~5세</span>
										<div className={styles.bar}>
											<span style={{ width: "42%" }}>
												<span>6명</span>
											</span>
										</div>
									</li>
									<li>
										<span>특수장애</span>
										<div className={styles.bar}>
											<span style={{ width: "35%" }}>
												<span>4명</span>
											</span>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</li>
					<li onClick={() => setMenuOpen(2)} className={menuOpen === 2 ? "active" : ""}>
						<div className={`${styles["list-title"]}`}>
							<p>교직원</p>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							<div className={styles.box}>
								<div>현황</div>
								<div className="flex-align_center mt_20">
									{/* 그래프 영역 */}
									<div style={{ width: "13rem", height: "13rem", background: "#eee" }} />
									<ul className={`${styles["info-item"]} flex--item_1 ml_20`}>
										<li>
											<div className="color-title">
												<p className="light-blue">원장</p>
											</div>
											<span>1명</span>
										</li>
										<li>
											<div className="color-title">
												<p className="green">보육교사</p>
											</div>
											<span>7명</span>
										</li>
										<li>
											<div className="color-title">
												<p className="yellow">영양사/조리원</p>
											</div>
											<span>1명</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</li>
					<li onClick={() => setMenuOpen(3)} className={menuOpen === 3 ? "active" : ""}>
						<div className={`${styles["list-title"]}`}>
							<p>시설</p>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							<div className={styles.box}>
								<div className={styles["list-item"]}>
									<div>
										<span>보육실</span>
										<span>5개(188㎡)</span>
									</div>
									<div>
										<span>놀이터</span>
										<span>2개</span>
									</div>
									<div>
										<span>CCTV 설치</span>
										<span>13대</span>
									</div>
								</div>
							</div>
						</div>
					</li>
				</ul>

				<div className={`${styles["guide-bottom"]} mt_40`}>어린이집 정보공개포털에서 받아오는 정보입니다.</div>
			</div>
		</div>
	)
}

export default SchoolDetail1